import { EventEmitter, inject, Injectable } from '@angular/core';
import { EmailData } from '../interfaces/interfaces';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationBarModel, NotificationBarType } from '../component/sections/notificationbar/notificationbar.model';
import { Observable, throwError } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class SiteproviderService {

  http = inject(HttpClient);

  constructor() {
  }

  created = new EventEmitter<NotificationBarModel>();

  onError(incomingMessage: string) {
    this.create({ message: incomingMessage, type: NotificationBarType.Error});
  }

  onInfo(incomingMessage: string) {
     this.create({ message: incomingMessage, type: NotificationBarType.Info});
  }

  onSuccess(incomingMessage: string) {
    this.create({ message: incomingMessage, type: NotificationBarType.Success});
  }

  onWarning(incomingMessage: string) {
    this.create({ message: incomingMessage, type: NotificationBarType.Warning});
  }

  postContactEmail(data: EmailData) {
    return this.http.post<any>(environment.apiUrl + '/email', data, httpOptions);
  }

  getPDF() {
    return '/assets/docs/JibrantWashingtonResume.pdf';
  }

  handleError(error: any) {
    return throwError(() => new Error('Error Occurred'));
  }

  create(notificationBar: NotificationBarModel) {
    this.created.emit(notificationBar);
  }
  
}
